import { useEffect, useState } from "react";
import { submitBug } from "../../firebase";

export default function SubmitBugModal ({ isOpen, onClose, user }) {
    const [bugText, setBugText] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    useEffect(() => {
        if (!isOpen) return;

        
    }, [isOpen]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!bugText.trim()) return;

        try {
            setIsSubmitting(true);
            setSuccessMessage("");

            // Limit the amount of characters for a bug report
            submitBug(user.currentUser.name, bugText);

            setBugText("");
            setSuccessMessage("Thanks. Your bug report has been submitted.");
        } catch (error) {
            console.error("Error submitting bug report:", error);
            setSuccessMessage("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return(
        <div className="modal-overlay" role="dialog" aria-modal="true">
            <div 
                className="bug-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="bug-modal-title"
            >
                <button
                    className="bug-modal-close"
                    onClick={onClose}
                    type="button"
                    aria-label="Close modal"
                >
                ×
                </button>

                <h2 id="bug-modal-title">Report a Bug</h2>
                <p className="bug-modal-description">
                Tell us what went wrong and, if possible, include the page and steps to reproduce it.
                </p>

                <form onSubmit={handleSubmit}>
                    <textarea
                        className="bug-modal-textarea"
                        value={bugText}
                        onChange={(event) => setBugText(event.target.value)}
                        placeholder="Example: On the movie details page, clicking 'Add to List' does nothing."
                        rows="6"
                    />

                    <button
                        className="bug-modal-submit"
                        type="submit"
                        disabled={isSubmitting || !bugText.trim()}
                    >
                        {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                </form>

                {successMessage && (
                <p className="bug-modal-message">{successMessage}</p>
                )}
            </div>
        </div>
    )
}